/* eslint-disable camelcase */
import { useBoolean } from '@chakra-ui/hooks'
import { useToast } from '@chakra-ui/react'
import * as crypto from 'crypto-js'
import produce from 'immer'
import fileDownload from 'js-file-download'
import { createContext, FC, useCallback, useMemo, useState } from 'react'
import { FaHistory } from 'react-icons/fa'
import { decodeToken } from 'react-jwt'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import paramsHelper from '@helper/params'
import {
  decrypterHeaderStorange,
  encrypteHeaderStorange
} from '@helper/util/cryptoStorange'
import parametrization from '@service/parametrization'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import {
  ITableGridAction,
  ITableHeader
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  HistoricOptimizer,
  IOptimizerStorangeContext,
  ISelectedLevel,
  ProductCategory,
  ResumoData,
  TraderOff
} from '@base/@types/providers/Optimizer/Optimizer'
import type {
  Pagination,
  IParams,
  IUpdateParams,
  IUpdateParamsEdit,
  Historic,
  HistoricUpdate
} from '@base/@types/providers/Optimizer/Optimizer'
import { IFilter } from '@base/@types/providers/Shared/FiltersProvider'
import optimizerHeader from '@base/variables/parametrization-supply.header'

const OptimizerStorangeProvider: FC = ({ children }) => {
  const toast = useToast()

  const [loading, setLoading] = useState(false)
  const [loadingSecondView, setLoadingSecondView] = useState(false)
  const [loadingTable, _setLoadingTable] = useState(false)
  const [filters, setFilters] = useBoolean(true)
  const [fastQuery, _setFastQuery] = useState<string>('')
  const [indexStkTotal, setIndexStkTotal] = useImmer<number>(null)
  const [indexStkOtimizar, setIndexStkOtimizar] = useImmer<number>(null)
  const [query, setQuery] = useState('')
  const [filename, setFilename] = useState(
    'Otimizador Estoque Seguranca - Relatório'
  )
  const [_selected, _setSelected] = useState<any>()
  const [fetching, _setFetching] = useState(false)
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )
  const token = userInfos?.body?.access_token

  const decodedToken: any = decodeToken(token)
  const roleToken = decodedToken?.role
  let idsVisible: any[] = []
  if (decodedToken?.parametrosAbastecimento) {
    // eslint-disable-next-line unused-imports/no-unused-vars
    idsVisible = decodedToken
      ? decodedToken?.parametrosAbastecimento?.split(',')
      : []
  }

  const [dataHistoric, updateDataHistoric] = useImmer<HistoricOptimizer[]>([])
  const [dataOriginal, updateDataOriginal] = useImmer<TraderOff>({
    estoqueAtual: 0,
    rupturaAtual: 0,
    estoques: [],
    skusStkTotal: 0,
    skusStkASerOtimizado: 0,
    skusStkSemOtimizacao: 0,
    skusStkOtimizado: 0,
    centroStkTotal: 0,
    centroStkASerOtimizado: 0,
    centroStkSemOtimizacao: 0,
    centroStkOtimizado: 0,
    custoMedioStkTotal: 0,
    custoMedioStkASerOtimizado: 0,
    custoMedioStkSemOtimizacao: 0,
    custoMedioStkOtimizado: 0
  })
  const [loadingModalHistoric, setLoadingModalHistoric] = useState(false)
  const [showingModalHistoric] = useState(false)

  const [dataHistoricV2, updateDataHistoricV2] = useImmer<Historic>({
    data: '',
    sclLegado: {},
    scL4Novo: {},
    possuiHistorico: false
  })
  const [loadingModalHistoricV2, setLoadingModalHistoricV2] = useState(false)
  const [showingModalHistoricV2, setShowingModalHistoricV2] = useState(false)

  const [dataHistoricV3, updateDataHistoricV3] = useImmer<Historic>({
    data: '',
    sclLegado: {},
    scL4Novo: {},
    possuiHistorico: false
  })
  const [loadingModalHistoricV3, setLoadingModalHistoricV3] = useState(false)
  const [showingModalHistoricV3, setShowingModalHistoricV3] = useState(false)

  const [dataHistoricUpdate, updateDataHistoricUpdate] = useImmer<
    HistoricUpdate[]
  >([])
  const [loadingModalHistoricUpdate, setLoadingModalHistoricUpdate] =
    useState(false)
  const [showingModalHistoricUpdate, setShowingModalHistoricUpdate] =
    useState(false)

  const [dataHistoricLeadTime, updateDataHistoricLeadTime] = useImmer<any[]>([])
  const [loadingModalHistoricLeadTime, setLoadingModalHistoricLeadTime] =
    useState(false)
  const [showingModalHistoriLeadTime, setShowingModalHistoricLeadTime] =
    useState(false)

  const [_error, setError] = useState<string | undefined>()

  // const [data, updateData] = useImmer<RootObject>({
  //   resumoNivel: null,
  //   categoriaCompactaEstoque: null
  // })

  const [dataTradeOffEstoque, updateDataTradeOffEstoque] = useImmer<any[]>(null)
  const [dataTradeOff, updateDataTradeOff] = useImmer<any>({})
  const [dataTradeOffResume, updateDataTradeOffResume] = useImmer<any>({})
  const [dataTradeOffWithPoint, updateDataTradeOffWithPoint] = useImmer<any[]>(
    []
  )
  const [dataDefault, updateDataDefault] = useImmer<any[]>(null)
  const [resumoData] = useImmer<ResumoData[]>([
    {
      titulo: 'Estoque Med R$',
      realizado: 0,
      otimizador: 0,
      diferenca: 0,
      diferencaPercentual: 0
    },
    {
      titulo: 'Nivel Serv (%)',
      realizado: 0,
      otimizador: 0,
      diferenca: 0,
      diferencaPercentual: 0
    }
  ])

  const [dataCategory, updateDataCategory] = useImmer<ProductCategory[]>([])
  const [dataProduct, updateDataProduct] = useImmer<ProductCategory>(null)
  const [fileUpload, setUpload] = useImmer([] as any)

  const [hiddenColumns, _updateHiddenColumns] = useImmer<string[]>([])

  const [selecteds, setSelecteds] = useImmer([] as any)
  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })
  const [filterEdit, updateCenters] = useImmer({
    centers: [],
    distributionCenters: []
  })

  const [paramsEdit, updateEditParams] = useImmer({
    abastercer: 0,
    tipoSuprimento: '',
    politicaEstoque: '',
    incluirPrevisaoLeadTime: '',
    maximo: '',
    frequenciaDePedidos: '',
    leadTime: '',
    tempoDeEspera: '',
    loteMultiplo: '',
    politicaDeEstoqueArbitraria: '',
    loteMinimoCD: '',
    estoqueArbitrado: '',
    cdDeOrigem: '',
    status: '',
    clusterCentro: '',
    clusterProduto: '',
    estoqueMinimo: '',
    utilizarEstoqueMinimo: ''
  })

  // REAL
  const [selectedotimizer, setSelectedotimizer] = useImmer<ISelectedLevel>(null)
  const [selectedCategoria, setSelectedCategoria] =
    useImmer<ISelectedLevel>(null)
  const [selectedProduct, setSelectedProduct] = useImmer<ISelectedLevel>(null)
  const [tabs, settabs] = useImmer<any[]>([1])
  const [indexTab, setIndex] = useState(1)
  const parseCommonFilters = (values: any[]): IFilter[] => {
    return values.map((filter: any) => ({
      value: filter.id || filter.codigo,
      label: `${filter.id || filter.codigo} - ${filter.descricao}`
    }))
  }

  const settab = useCallback(
    async (index: any, _key?: any) => {
      // if (key !== null) {
      //   const dateProduct = data.categoriaCompactaEstoque.filter(
      //     x => x.key === key
      //   )[0]
      //   updateDataCategory(dateProduct.produtos)
      // }
      settabs(prevState =>
        produce(prevState, draftState => {
          draftState.push(index)
        })
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [settabs, updateDataCategory]
  )

  const handleUpload = useCallback(
    (event: any) => {
      setUpload(event.target.files)
    },
    [setUpload]
  )

  const handleSelect = useCallback(
    async (index: any) => {
      const supply = index['id-id']
      if (!selecteds.includes(supply)) {
        setSelecteds([...selecteds, supply])
      } else {
        setSelecteds(selecteds.filter((prop: any) => prop !== supply))
      }
    },
    [setSelecteds, selecteds]
  )

  const handleUpdateEditParams = ({ name, value }: IUpdateParamsEdit) => {
    updateEditParams(draft => {
      if (name === 'status') {
        draft.status = value
      } else if (name === 'abastercer') {
        draft.abastercer = value
      } else if (name === 'cdDeOrigem') {
        draft.cdDeOrigem = value
      } else if (name === 'estoqueArbitrado') {
        draft.estoqueArbitrado = value
      } else if (name === 'frequenciaDePedidos') {
        draft.frequenciaDePedidos = value
      } else if (name === 'incluirPrevisaoLeadTime') {
        draft.incluirPrevisaoLeadTime = value
      } else if (name === 'leadTime') {
        draft.leadTime = value
      } else if (name === 'loteMinimoCD') {
        draft.loteMinimoCD = value
      } else if (name === 'loteMultiplo') {
        draft.loteMultiplo = value
      } else if (name === 'maximo') {
        draft.maximo = value
      } else if (name === 'politicaDeEstoqueArbitraria') {
        draft.politicaDeEstoqueArbitraria = value
      } else if (name === 'politicaEstoque') {
        draft.politicaEstoque = value
      } else if (name === 'tipoSuprimento') {
        draft.tipoSuprimento = value
      } else if (name === 'tempoDeEspera') {
        draft.tempoDeEspera = value
      } else if (name === 'clusterProduto') {
        draft.clusterProduto = value
      } else if (name === 'clusterCentro') {
        draft.clusterCentro = value
      } else if (name === 'utilizarEstoqueMinimo') {
        draft.utilizarEstoqueMinimo = value
      } else if (name === 'estoqueMinimo') {
        draft.estoqueMinimo = value
      } else if (name === 'estoqueMinimo') {
        draft.estoqueMinimo = value
      }
    })
  }

  const getCenters = useCallback(async () => {
    try {
      const { data: distributionCenters } =
        await parametrization.getCentersParametrization()

      updateCenters(draft => {
        return Object.assign(draft, {
          distributionCenters: parseCommonFilters(distributionCenters.data)
        })
      })
    } catch (error: any) {
      const { data } = error.response

      setError(
        data.message ||
          'Ocorreu um problema interno. Tente novamente mais tarde'
      )
    }
    setLoading(false)
  }, [updateCenters])

  const handleSelectAll = () => {}

  const [params, updateParams] = useImmer<IParams>({
    lojasIds: [],
    centerIds: [],
    abcCurvesIds: [],
    mundoIds: [],
    categoriasCompactasIds: [],
    fornecedoresIds: [],
    gerenteCategoriaIds: [],
    gerenteProdutoIds: [],
    produtosIds: [],
    tipoCentroSelectIds: [],
    statusProduto: [],
    curvaAbc: [],
    curvaIgualZeroRadio: '',
    produtoSemFornecedorRadio: '',
    precisaAbastecerRadio: '',
    clusterCentro: [],
    clusterProduto: [],
    subCategoriaSelectIds: []
  })

  const [headers, updateHeaders] = useImmer<ITableHeader[]>(optimizerHeader)
  const handleHeaderLocalStorange = useCallback(() => {
    encrypteHeaderStorange('optimizerHeader', headers)

    if (!localStorage.getItem('optimizerHeader')) {
      encrypteHeaderStorange('optimizerHeader', headers)
    } else {
      localStorage.removeItem('optimizerHeader')
      encrypteHeaderStorange('optimizerHeader', headers)
    }
  }, [headers])

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...headers]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show,
        notShowColumn: newHeaders[index].columns[column].notShowColumn
          ? !newHeaders[index].columns[column].notShowColumn
          : true,
        isNumeric: newHeaders[index].columns[column].isNumeric
      }

      updateHeaders(newHeaders)
      handleHeaderLocalStorange()
    },
    [handleHeaderLocalStorange, headers, updateHeaders]
  )

  const handleLocalParams = useCallback(async () => {
    if (localStorage.getItem('optimizerParams')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('optimizerParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      updateParams(newParams)
    } else {
      localStorage.setItem(
        'optimizerParams',
        crypto.AES.encrypt(JSON.stringify(params), 'CHAVE').toString()
      )
    }
  }, [updateParams, params])

  const handleStorange = useCallback(async () => {
    if (localStorage.getItem('optimizerHeader')) {
      const newHeader = decrypterHeaderStorange('optimizerHeader')

      updateHeaders(newHeader)
    }
  }, [updateHeaders])

  const clearAllFilters = () => {
    updateParams({
      ...params,
      tipoCentroSelectIds: [],
      lojasIds: [],
      centerIds: [],
      abcCurvesIds: [],
      mundoIds: [],
      categoriasCompactasIds: [],
      fornecedoresIds: [],
      produtosIds: [],
      gerenteCategoriaIds: [],
      gerenteProdutoIds: [],
      statusProduto: [],
      curvaAbc: [],
      curvaIgualZeroRadio: '',
      produtoSemFornecedorRadio: '',
      precisaAbastecerRadio: '',
      clusterCentro: [],
      clusterProduto: [],
      subCategoriaSelectIds: []
    })
    if (localStorage.getItem('optimizerParams')) {
      localStorage.setItem(
        'optimizerParams',
        crypto.AES.encrypt(
          JSON.stringify({
            ...params,
            tipoCentroSelectIds: [],
            lojasIds: [],
            centerIds: [],
            abcCurvesIds: [],
            mundoIds: [],
            categoriasCompactasIds: [],
            fornecedoresIds: [],
            produtosIds: [],
            gerenteCategoriaIds: [],
            gerenteProdutoIds: [],
            statusProduto: [],
            curvaAbc: [],
            curvaIgualZeroRadio: '',
            produtoSemFornecedorRadio: '',
            precisaAbastecerRadio: '',
            clusterProduto: [],
            clusterCentro: [],
            subCategoriaSelectIds: []
          }),
          'CHAVE'
        ).toString()
      )
    }
  }

  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams(draft => {
      draft[name] = value
    })
    if (localStorage.getItem('optimizerParams')) {
      const newParams: IParams[] = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('optimizerParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )

      localStorage.setItem(
        'optimizerParams',
        crypto.AES.encrypt(
          JSON.stringify({ ...newParams, [name]: value }),
          'CHAVE'
        ).toString()
      )
    }
  }

  const exportData = useCallback(async () => {
    // Monta o payload por ID de coluna, nao por posicao. O mapeamento
    // posicional anterior desalinhou quando o grupo "Ruptura" foi inserido no
    // header: o indice caia em outro grupo e, quando caia fora do array, o
    // ternario `? ... : true` devolvia TRUE — mandando como visivel coluna
    // que o usuario tinha desmarcado.
    const isShown = (group: string, id: string) => {
      const column = headers
        .find(item => item.group === group)
        ?.columns?.find(item => item.id === id)

      return column ? !!column.show : true
    }

    const configuracaoGrid = {
      centroConfiguracaoGrid: {
        codigo: isShown('Centro', 'centro-codigo'),
        nome: isShown('Centro', 'centro-id')
      },
      produtoConfiguracaoGrid: {
        codigo: isShown('Produto', 'produto-id'),
        // "material" e a coluna "Código do Fornecedor" do grid.
        material: isShown('Produto', 'fornecedor-codigo-produto'),
        status: isShown('Produto', 'produto-status'),
        curvaABC: isShown('Produto', 'produto-curva-abc'),
        // Coluna comentada no header: nao aparece no grid, entao nao deve
        // aparecer no export.
        curvaABCEmpresa: false,
        grupoSeparacao: isShown('Produto', 'produto-grupo-separacao')
      },
      parametrosConfiguracaoGrid: {
        tipoSuprimento: isShown('Parâmetros', 'parametros-tipo-suprimentos'),
        abastecer: isShown('Parâmetros', 'parametros-abastecer'),
        eMax: isShown('Parâmetros', 'parametros-emax'),
        leadTime: isShown('Parâmetros', 'parametros-lead-time'),
        incluirPrevisaoLeadTime: isShown(
          'Parâmetros',
          'parametros-previsao-lead-time'
        ),
        frequenciaPedidos: isShown(
          'Parâmetros',
          'parametros-frequencia-pedidos'
        ),
        loteMinimoCD: isShown('Parâmetros', 'parametros-lote-minimo-cd'),
        loteMultiplo: isShown('Parâmetros', 'parametros-lote-multiplo'),
        // Coluna comentada no header: nao aparece no grid, entao nao deve
        // aparecer no export.
        estoqueArbitrado: false
      },
      politicaEstoqueSegurancaConfiguracaoGrid: {
        arbitrada: isShown(
          'Politica de Estoque de Segurança',
          'politica-arbritada'
        ),
        otimizada: isShown(
          'Politica de Estoque de Segurança',
          'politica-otimizada'
        ),
        utilizarOtimizada: isShown(
          'Politica de Estoque de Segurança',
          'politica-utilizar-otimizada'
        )
      },
      fornecedorConfiguracaoGrid: {
        nome: isShown('Fornecedor', 'fornecedor-nome')
      },
      cdOrigemConfiguracaoGrid: {
        codigo: isShown('Cd de Origem', 'cd-origem-codigo'),
        nome: isShown('Cd de Origem', 'cd-origem-nome')
      },
      vendaMediaConfiguracaoGrid: {
        totalCentro: isShown('Venda Média', 'venda-media-total'),
        retiraCentro: isShown('Venda Média', 'venda-media-retira')
      },
      diasVendaConfiguracaoGrid: {
        totalCentro: isShown('Dias de Venda', 'dias-venda-total'),
        retiraCentro: isShown('Dias de Venda', 'dias-venda-retira')
      },
      estoqueConfiguracaoGrid: {
        estoqueAtual: isShown('Estoque', 'estoque-atual'),
        estoqueTransito: isShown('Estoque', 'estoque-transito'),
        ultimaVendaLoja: isShown('Estoque', 'estoque-ultima-venda-loja'),
        ultimaVendaEmpresa: isShown('Estoque', 'estoque-ultima-venda-empresa'),
        endereco: isShown('Estoque', 'estoque-endereco')
      }
    }
    Swal.fire({
      title: 'Exportar dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    const paramsToSend = {
      configuracaoGrid,
      categoriasCompactasIds: paramsHelper.parse(params.categoriasCompactasIds),
      produtosIds: paramsHelper.parse(params.produtosIds),
      gerenteProdutoIds: paramsHelper.parse(params.gerenteProdutoIds),
      gerenteCategoriaIds: paramsHelper.parse(params.gerenteCategoriaIds),
      fornecedoresIds: paramsHelper.parse(params.fornecedoresIds),
      mundoIds: paramsHelper.parse(params.mundoIds),
      lojasIds: paramsHelper.parse(params.lojasIds),
      curva: paramsHelper.parse(params.abcCurvesIds),
      centersIds: paramsHelper.parse(params.centerIds),
      statusProduto: paramsHelper.parse(params.statusProduto),
      subCategoriaId: paramsHelper.parse(params.subCategoriaSelectIds),
      curvaAbc:
        params.curvaAbc.length > 0 ? paramsHelper.parse(params.curvaAbc) : [],
      curvaABCIgualZero:
        params.curvaIgualZeroRadio !== ''
          ? params.curvaIgualZeroRadio === '> 0'
          : null,
      produtoSemFornecedor:
        params.produtoSemFornecedorRadio !== ''
          ? params.produtoSemFornecedorRadio === 'sim'
          : null,
      precisaAbastecer:
        params.precisaAbastecerRadio !== ''
          ? params.precisaAbastecerRadio === 'sim'
          : null
    }
    try {
      const { data: res } = await parametrization.postExportSupply(paramsToSend)
      fileDownload(res, filename + '.csv')
      Swal.close()
    } catch (error: any) {
      const { data } = error.response
      Swal.close()
      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 2000,
        isClosable: true
      })

      setLoading(false)
    }
  }, [toast, filename, params, headers])

  const handlePageChange = useCallback(async (_page: number) => {}, [])

  function insertSorted(arr: number[], num: number): number[] {
    // eslint-disable-next-line no-debugger
    // debugger
    if (arr.includes(num)) {
      return arr // Return the array as is if the number already exists
    }
    const index = arr.findIndex(el => el > num)
    if (index === -1) {
      arr.push(num) // If no element is greater, append at the end
    } else {
      arr.splice(index, 0, num) // Insert at the correct position
    }
    return arr
  }
  function interpolateNulls(data: (number | null)[]) {
    const result = [...data]
    for (let i = 0; i < result.length; i++) {
      if (result[i] === null) {
        // Encontrar os índices dos pontos antes e depois do null
        const prevIndex = i - 1
        const nextIndex = result.findIndex(
          (val, idx) => idx > i && val !== null
        )
        if (prevIndex >= 0 && nextIndex > i) {
          // Interpolação linear
          const prevValue = result[prevIndex]!
          const nextValue = result[nextIndex]!
          const step = (nextValue - prevValue) / (nextIndex - prevIndex)
          result[i] = prevValue + step * (i - prevIndex)
        }
      }
    }
    return result
  }

  const getData = useCallback(async () => {
    handleStorange()
    // await getMaintence()
    // console.log(params)

    // const isDisabledProgress =
    //   params.tipoCentroSelectIds.length !== 0 &&
    //   params.lojasIds.length !== 0 &&
    //   (params.categoriasCompactasIds.length !== 0 ||
    //     params.mundoIds.length !== 0)

    // if (!isDisabledProgress) {
    //   toast({
    //     title: 'Atenção',
    //     description: 'Selecionar ao menos um filtro',
    //     status: 'warning',
    //     duration: 2000,
    //     isClosable: true
    //   })
    //   return
    // }
    setLoading(true)

    try {
      parametrization
        .getOtimizerTraderOff({
          tipoCentro: paramsHelper.parseType(params.tipoCentroSelectIds),
          empresaId: paramsHelper.parse(params.lojasIds),
          curva: paramsHelper.parse(params.abcCurvesIds),
          lojaId: paramsHelper.parse(params.centerIds),
          mundoId: paramsHelper.parse(params.mundoIds),
          categoriaCompactaId: paramsHelper.parse(
            params.categoriasCompactasIds
          ),
          subCategoriaId: paramsHelper.parse(params.subCategoriaSelectIds)
        })
        .then(({ data: { data } }) => {
          // console.log(data)
          // updateShowTableInTable(data)
          let serie1 = data?.estoques?.map((x: any) => x.rupturaPercentual)

          // const serie2 = data?.estoques?.map((x: any) => x.rupturaPercentual)
          const categories1 = data?.estoques?.map((x: any) => x.estoqueReais)
          // console.log('trade off', data)
          let sortedArray = insertSorted(categories1, data?.estoqueAtual)
          sortedArray = insertSorted(categories1, data?.estoqueAOtimizar)
          const indice = sortedArray.indexOf(data?.estoqueAtual)
          setIndexStkTotal(indice)
          const otimizadorGraph1: (number | null)[] = sortedArray.map(
            (x, index) => {
              return index === indice ? data?.rupturaAtual : null
            }
          )

          const indiceAOtimizar = sortedArray.indexOf(data?.estoqueAOtimizar)
          setIndexStkOtimizar(indiceAOtimizar)

          const otimizadorGraphAOtimizar: (number | null)[] = sortedArray.map(
            (x, index) => {
              return index === indiceAOtimizar ? data?.rupturaAOtimizar : null
            }
          )
          serie1.splice(indiceAOtimizar, 0, null)
          serie1 = interpolateNulls(serie1)
          updateDataTradeOff({
            categoria: categories1,
            series: [
              {
                name: 'Curva Trade Off',
                data: serie1,
                type: 'line',
                color: '#04671a'
              },
              {
                name: 'Stk Total',
                data: otimizadorGraph1,
                type: 'line',
                color: '#1b2310'
              },
              {
                name: 'Stk a Otimizar',
                data: otimizadorGraphAOtimizar,
                type: 'line',
                color: '#5e75d1'
              }
            ]
          })
          updateDataTradeOffEstoque(data?.estoques)
          const estData = data?.estoques
          delete data.estoques
          updateDataTradeOffResume(data)
          settabs([1])

          setFilters.toggle()
          setSelectedotimizer(null)
          setSelectedCategoria(null)
          updateDataProduct(null)
          setIndex(1)
          updatePagination(pagination)
          setLoading(false)

          const novoObjeto = {
            ...data,
            estoques: estData // Adicionando a propriedade 'estoques' com um array vazio
          }
          updateDataOriginal(novoObjeto)
          getHistoric()
        })
        .catch(_error => {
          const message =
            _error.response?.status === 400
              ? _error.response?.data?.message
              : 'Ocorreu um problema interno. Tente novamente mais tarde'
          toast({
            title: 'Atenção.',
            description: message,
            status: _error.response?.status === 400 ? 'warning' : 'error',
            duration: 2000,
            isClosable: true
          })

          setLoading(false)
          updateDataTradeOff([])
          updateDataTradeOffEstoque(null)
        })

      parametrization
        .getOtimizerDefault()
        .then(({ data: { data } }) => {
          updateDataDefault(data)
        })
        .catch(() => {
          updateDataDefault([])
        })
    } catch (Expe) {
      setLoading(false)
      const message = 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'error',
        duration: 2000,
        isClosable: true
      })

      updateDataTradeOff([])
      updateDataTradeOffEstoque(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    handleStorange,
    params.tipoCentroSelectIds,
    params.lojasIds,
    params.abcCurvesIds,
    params.centerIds,
    params.mundoIds,
    params.categoriasCompactasIds,
    updateDataTradeOff,
    updateDataTradeOffEstoque,
    updateDataTradeOffResume,
    settabs,
    setFilters,
    setSelectedotimizer,
    setSelectedCategoria,
    updateDataProduct,
    updatePagination,
    pagination,
    updateDataOriginal,
    toast,
    updateDataDefault
  ])

  const getLevelSelected = (level: any) => {
    // eslint-disable-next-line no-debugger
    debugger
    if (level < indexStkOtimizar) {
      return level
    }
    return level + 1
  }
  const getDataWithPoint = useCallback(
    async (point: any) => {
      handleStorange()
      // await getMaintence()
      const value = dataTradeOff.series[0]?.data[getLevelSelected(point)]
      // eslint-disable-next-line no-debugger
      debugger
      const otimizadorGraph1: (number | null)[] =
        dataTradeOff.series[0]?.data.map((x: any, index: any) => {
          return index === getLevelSelected(point) ? value : null
        })
      updateDataTradeOff({
        categoria: dataTradeOff?.categoria,
        series: [
          {
            name: 'Curva Trade Off',
            data: dataTradeOff.series[0]?.data,
            type: 'line',
            color: '#04671a'
          },
          {
            name: 'Stk total',
            data: dataTradeOff.series[1]?.data,
            type: 'line',
            color: '#1b2310'
          },
          {
            name: 'Stk a Otimizar',
            data: dataTradeOff.series[2]?.data,
            type: 'line',
            color: '#5e75d1'
          },

          // Condicionalmente adicionar o objeto
          ...(dataTradeOff.series[3] != null &&
          dataTradeOff.series[3].name === 'Otimizado'
            ? [
                {
                  name: 'Otimizado',
                  data: dataTradeOff.series[2]?.data,
                  type: 'line',
                  color: '#FFC300'
                }
              ]
            : []),
          ...(dataTradeOff.series[4] != null
            ? [
                {
                  name: 'Otimizado',
                  data: dataTradeOff.series[4]?.data,
                  type: 'line',
                  color: '#FFC300'
                }
              ]
            : []),
          {
            name: 'Selecionado',
            data: otimizadorGraph1,
            type: 'line',
            color: '#ff0000'
          }
        ]
      })

      setLoadingSecondView(true)

      try {
        parametrization
          .getOtimizerTraderOffWithPoint(
            {
              tipoCentro: paramsHelper.parseType(params.tipoCentroSelectIds),
              curva: paramsHelper.parse(params.abcCurvesIds),
              lojaId: paramsHelper.parse(params.centerIds),
              empresaId: paramsHelper.parse(params.lojasIds),
              mundoId: paramsHelper.parse(params.mundoIds),
              categoriaCompactaId: paramsHelper.parse(
                params.categoriasCompactasIds
              ),
              subCategoriaId: paramsHelper.parse(params.subCategoriaSelectIds)
            },
            point
          )
          .then(({ data: { data } }) => {
            updateDataTradeOffWithPoint(data)
            setSelectedCategoria(null)
            updateDataProduct(null)
            setIndex(2)

            // setFilters.toggle()
            updatePagination(pagination)
            setLoadingSecondView(false)
          })
          .catch(() => {
            setLoading(false)
            updateDataTradeOff({})
          })
      } catch {
        setLoadingSecondView(false)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      handleStorange,
      dataTradeOff.series,
      dataTradeOff?.categoria,
      updateDataTradeOff,
      params.tipoCentroSelectIds,
      params.lojasIds,
      params.mundoIds,
      params.categoriasCompactasIds,
      updateDataTradeOffWithPoint,
      setSelectedCategoria,
      updateDataProduct,
      updatePagination,
      pagination
    ]
  )

  const postUpload = useCallback(
    async (event: any) => {
      setLoading(true)

      parametrization
        .uploadSupply({
          file: event.target.files[0]
        })
        .then(() => {
          getData()
          toast({
            title: 'Sucesso',
            description: 'Alterações realizadas com Sucesso',
            status: 'success',
            duration: 2000,
            isClosable: true
          })
          setLoading(false)
        })
        .catch(response => {
          let htmlLines = ''
          for (let aux = 0; aux < response.response.data.data.length; aux++) {
            htmlLines += '<li>' + response.response.data.data[aux] + '</>'
          }
          Swal.fire({
            title: '<strong>Ops, houver um error</u></strong>',
            icon: 'error',
            html: 'Verificar os erros abaixo, ' + htmlLines,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false
          })
          // console.log(response.response?.data?.message)
          // const message =
          //   response.response?.status === 400
          //     ? response.response?.data?.message
          //     : 'Ocorreu um problema interno. Tente novamente mais tarde'
          // toast({
          //   title: 'Erro Requisição.',
          //   description: message,
          //   status: 'error',
          //   duration: 2000,
          //   isClosable: true
          // })
          setLoading(false)
        })
    },
    [toast, setLoading, getData]
  )

  const setData = useCallback(async () => {}, [])

  const filtersList = useMemo<ILayoutFilter[]>(() => {
    return [
      {
        id: 'lojasIds',
        label: 'Empresa',
        filterId: 'companies',
        type: 'select',
        isMulti: true
        // limit: 1
      },
      {
        id: 'tipoCentroSelectIds',
        label: 'Tipo de Centro',
        filterId: 'centerTypes',
        type: 'select',
        isMulti: true
      },
      {
        id: 'centerIds',
        label: 'Centro',
        filterId: 'centers',
        type: 'select',
        isMulti: true
        // limit: 1
      },

      // {
      //   id: 'mundoIds',
      //   label: 'Mundo',
      //   filterId: 'worlds',

      //   type: 'select',
      //   isMulti: true
      //   // limit: 1
      // },
      {
        id: 'categoriasCompactasIds',
        label: 'Categoria Compacta',
        filterId: 'compactCategories',

        type: 'select',
        isMulti: true
        // limit: 1
      },
      {
        id: 'subCategoriaSelectIds',
        label: 'Sub Categoria',
        filterId: 'subCategories',

        type: 'select',
        isMulti: true
      },
      {
        id: 'abcCurvesIds',
        label: 'Curva',
        filterId: 'abcCurves',

        type: 'select',
        isMulti: true
        // limit: 1
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return []
  }, [])

  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'checkbox',
        icon: <FaHistory />,
        onChange: handleSelect,
        selecteds: selecteds,
        isMulti: true
      },
      roleToken === 'Administrador' || roleToken === 'Parceiro'
        ? {
            type: 'icon',
            icon: <FaHistory />
          }
        : {}
    ]
  }, [handleSelect, roleToken, selecteds])

  const getHistoric = useCallback(async () => {
    parametrization
      .getHistoricOptimizer()
      .then(data => {
        if (data != null) {
          updateDataHistoric(data.data)
        }
      })
      .catch(_ex => {
        updateDataHistoric([])
      })
  }, [updateDataHistoric])

  const getHistoricV2 = useCallback(
    async (idProduto: number, idLoja: number) => {
      if (idLoja !== 1500) {
        return
      }
      setLoadingModalHistoricV2(true)
      setShowingModalHistoricV2(true)
      parametrization
        .getHistoricV2(idProduto, idLoja)
        .then(({ data: { data } }) => {
          updateDataHistoricV2(data)
          setLoadingModalHistoricV2(false)
        })
        .catch(() => {
          updateDataHistoricV2({
            data: '',
            sclLegado: {},
            scL4Novo: {},
            possuiHistorico: false
          })
          setLoadingModalHistoricV2(false)
        })
    },
    [setLoadingModalHistoricV2, updateDataHistoricV2]
  )
  const getHistoricV3 = useCallback(
    async (idProduto: number, idLoja: number) => {
      if (idLoja !== 2800) {
        return
      }
      setLoadingModalHistoricV3(true)
      setShowingModalHistoricV3(true)
      parametrization
        .getHistoricV3(idProduto, idLoja)
        .then(({ data: { data } }) => {
          updateDataHistoricV3(data)
          setLoadingModalHistoricV3(false)
        })
        .catch(() => {
          updateDataHistoricV3({
            data: '',
            sclLegado: {},
            scL4Novo: {},
            possuiHistorico: false
          })
          setLoadingModalHistoricV3(false)
        })
    },
    [setLoadingModalHistoricV3, updateDataHistoricV3]
  )

  const getHistoricUpdate = useCallback(
    async (idProduto: number, idLoja: number) => {
      setLoadingModalHistoricUpdate(true)
      setShowingModalHistoricUpdate(true)
      parametrization
        .getHistoricUpdate(idProduto, idLoja)
        .then(({ data: { data } }) => {
          updateDataHistoricUpdate(data)
          setLoadingModalHistoricUpdate(false)
        })
        .catch(() => {
          updateDataHistoricUpdate([])
          setLoadingModalHistoricUpdate(false)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setLoadingModalHistoric, updateDataHistoric]
  )

  const getHistoricLeadTime = useCallback(
    async (idProduto: number, idLoja: number) => {
      setLoadingModalHistoricLeadTime(true)
      setShowingModalHistoricLeadTime(true)
      parametrization
        .getHistoricLeadTime(idProduto, idLoja)
        .then(({ data: { data } }) => {
          updateDataHistoricLeadTime(data)
          setLoadingModalHistoricLeadTime(false)
        })
        .catch(() => {
          updateDataHistoricLeadTime([])
          setLoadingModalHistoricLeadTime(false)
        })
    },
    [updateDataHistoricLeadTime]
  )

  const clearHistorics = useCallback(async () => {
    updateDataHistoricV2({
      data: '',
      sclLegado: {},
      scL4Novo: {},
      possuiHistorico: false
    })
    updateDataHistoricV3({
      data: '',
      sclLegado: {},
      scL4Novo: {},
      possuiHistorico: false
    })
    updateDataHistoric([])
    updateDataHistoricUpdate([])
    updateDataHistoricLeadTime([])
  }, [
    updateDataHistoric,
    updateDataHistoricLeadTime,
    updateDataHistoricUpdate,
    updateDataHistoricV2,
    updateDataHistoricV3
  ])

  const setSelectedlevelAction = useCallback(
    async (level: string, curve: string, index: any) => {
      if (index === 1) {
        setSelectedotimizer({
          level: level,
          curve: curve
        })
        // if (curve === null) {
        //   const selectData = data?.resumoNivel.filter(x => x.nivel === level)[0]
        //   updateResumoData([
        //     {
        //       titulo: 'Estoque Med R$',
        //       realizado: selectData.estoqueMedioRealizado,
        //       otimizador: selectData.estoqueMedioOtimizado,
        //       diferenca:
        //         selectData.estoqueMedioOtimizado -
        //         selectData.estoqueMedioRealizado,
        //       diferencaPercentual: calcularPorcentagemDiferenca(selectData)
        //     },
        //     {
        //       titulo: 'Nivel Serv (%)',
        //       realizado: selectData.nivelServicoRealizado,
        //       otimizador: selectData.nivelServicoOtimizado,
        //       diferenca:
        //         (selectData.nivelServicoOtimizado -
        //           selectData.nivelServicoRealizado) *
        //         100,
        //       diferencaPercentual:
        //         calcularPorcentagemDiferencaPercent(selectData)
        //     }
        //   ])
        // } else {
        //   const selectData = data?.categoriaCompactaEstoque.filter(
        //     x => x.categoriaCompactaDescricao === level && x.curvaABCD === curve
        //   )[0]
        //   updateResumoData([
        //     {
        //       titulo: 'Estoque Med R$',
        //       realizado: selectData.estoqueMedioRealizado,
        //       otimizador: selectData.estoqueMedioOtimizado,
        //       diferenca:
        //         selectData.estoqueMedioOtimizado -
        //         selectData.estoqueMedioRealizado,
        //       diferencaPercentual: calcularPorcentagemDiferenca(selectData)
        //     },
        //     {
        //       titulo: 'Nivel Serv (%)',
        //       realizado: selectData.nivelServicoRealizado,
        //       otimizador: selectData.nivelServicoOtimizado,
        //       diferenca:
        //         (selectData.nivelServicoOtimizado -
        //           selectData.nivelServicoRealizado) *
        //         100,
        //       diferencaPercentual:
        //         calcularPorcentagemDiferencaPercent(selectData)
        //     }
        //   ])
        // }
      }
      if (index === 2) {
        // eslint-disable-next-line no-debugger
        setSelectedCategoria({
          level: level,
          curve: curve
        })

        const selectData = dataTradeOffWithPoint.filter(
          (x: any) => x.produtoDescricao === level && x.curvaABCD === curve
        )[0]
        updateDataProduct(selectData)
      }
      if (index === 3) {
        setSelectedProduct({
          level: level,
          curve: curve
        })
      }
    },
    [
      dataTradeOffWithPoint,
      setSelectedCategoria,
      setSelectedProduct,
      setSelectedotimizer,
      updateDataProduct
    ]
  )

  const extractNumber = (text: string) => {
    const match = text.match(/\d+/) // Procura um ou mais dígitos na string
    return match ? parseInt(match[0], 10) : null // Converte o resultado para número
  }
  const saveOtimizer = useCallback(
    async (point?: any) => {
      const newOptimizer: {
        lojaId: any
        produtoId: any
        politicaOtimizada: any
      }[] = []
      dataTradeOffWithPoint.map((x: any) => {
        newOptimizer.push({
          lojaId: x.lojaId,
          produtoId: x.produtoId,
          politicaOtimizada: x.politicaOtimizada
        })
      })

      const putOptimizer = {
        filtros: {
          tipoCentro: paramsHelper.parseAllString(params.tipoCentroSelectIds),
          empresaId: paramsHelper.parseAllString(params.lojasIds),
          mundoId: paramsHelper.parseAllString(params.mundoIds),
          curva: paramsHelper.parse(params.abcCurvesIds),
          lojaId: paramsHelper.parseAllString(params.centerIds),
          categoriaCompactaId: paramsHelper.parseAllString(
            params.categoriasCompactasIds
          ),
          subCategoriaId: paramsHelper.parseAllString(
            params.subCategoriaSelectIds
          )
        },
        ponto: extractNumber(point),
        estoques: newOptimizer,
        curvaTradeOff: dataOriginal
      }
      const indexOtimizado = dataTradeOff.series.length
      parametrization
        .saveOtimizer(putOptimizer)
        .then(() => {
          updateDataTradeOff({
            categoria: dataTradeOff?.categoria,
            series: [
              {
                name: 'Curva Trade Off',
                data: dataTradeOff.series[0]?.data,
                type: 'line',
                color: '#04671a'
              },
              {
                name: 'Stk Total',
                data: dataTradeOff.series[1]?.data,
                type: 'line',
                color: '#1b2310'
              },
              {
                name: 'Stk a Otimizar',
                data: dataTradeOff.series[2]?.data,
                type: 'line',
                color: '#5e75d1'
              },
              {
                name: 'Otimizado',
                data: dataTradeOff.series[indexOtimizado === 4 ? 4 : 3]?.data,
                type: 'line',
                color: '#FFC300'
              }
            ]
          })
          updateDataProduct(null)
          Swal.fire({
            title: 'Sucesso!',
            text: 'A Otimização com ponto selecionado foi feito com sucesso!',
            icon: 'success',
            confirmButtonColor: '#4CAF50', // Cor de fundo personalizada
            confirmButtonText: 'OK'
          })
          getHistoric()
        })
        .catch(() => {
          // updateDataHistoricLeadTime([])
          // setLoadingModalHistoricLeadTime(false)
        })
    },
    [
      dataOriginal,
      dataTradeOff?.categoria,
      dataTradeOff.series,
      dataTradeOffWithPoint,
      getHistoric,
      params.abcCurvesIds,
      params.categoriasCompactasIds,
      params.centerIds,
      params.lojasIds,
      params.mundoIds,
      params.subCategoriaSelectIds,
      params.tipoCentroSelectIds,
      updateDataProduct,
      updateDataTradeOff
    ]
  )
  return (
    <OptimizerStorangeContext.Provider
      value={{
        loading,
        loadingTable,
        data: null,
        params,
        headers,
        fetching,
        actions,
        tableInteraction,
        selecteds,
        filterEdit,
        paramsEdit,
        fileUpload,
        pagination,
        filename,
        query,
        filters,
        hiddenColumns,
        fastQuery,
        filtersList,
        toggleColumn,
        handleUpdateParams,
        handleSelectAll,
        handleSelect,
        setQuery,
        clearAllFilters,
        handlePageChange,
        getHistoric,
        getHistoricV2,
        getHistoricV3,
        getData,
        exportData,
        clearHistorics,
        setData,
        handleUpdateEditParams,
        setFilters,
        handleUpload,
        postUpload,
        handleLocalParams,
        getCenters,
        setFilename,
        showingModalHistoric,
        loadingModalHistoric,
        dataHistoric,
        showingModalHistoricV2,
        loadingModalHistoricV2,
        dataHistoricV2,
        showingModalHistoricV3,
        loadingModalHistoricV3,
        dataHistoricV3,
        showingModalHistoricUpdate,
        loadingModalHistoricUpdate,
        getHistoricUpdate,
        dataHistoricUpdate,
        dataHistoricLeadTime,
        loadingModalHistoricLeadTime,
        showingModalHistoriLeadTime,
        getHistoricLeadTime,
        selectedotimizer,
        setSelectedlevelAction,
        settab,
        tabs,
        selectedCategoria,
        dataProduct,
        dataCategory,
        resumoData,
        selectedProduct,
        dataTradeOff,
        dataTradeOffWithPoint,
        dataTradeOffResume,
        getDataWithPoint,
        dataDefault,
        loadingSecondView,
        dataTradeOffEstoque,
        saveOtimizer,
        indexTab,
        setIndex,
        indexStkTotal,
        indexStkOtimizar
      }}
    >
      {children}
    </OptimizerStorangeContext.Provider>
  )
}

export default OptimizerStorangeProvider
export const OptimizerStorangeContext =
  createContext<IOptimizerStorangeContext>({} as IOptimizerStorangeContext)
